import type { ISerializationPort } from "@/core/ports";
import { BrowserStorageAdapter } from "@/infrastructure/adapters/browserStorage/BrowserStorage.adapter";
import { LocalStorageManager } from "@/infrastructure/services/localstorage/LocalStorage.manager";

export class LocalStorageAdapter extends BrowserStorageAdapter {
  constructor(serializer: ISerializationPort, prefix = "studioApp") {
    super(serializer, new LocalStorageManager(prefix));
  }
}
